import StorageLogger from '@/core/services/StorageLogger'

export default {
    install (app) {
        app.config.globalProperties.$logger = StorageLogger
    }
}
